<template>
  <div class="writeUpdate">
    <div class="top-nav-bar">
      <van-navBar title="发动态" @click-left="$router.back()">
        <i class="icon back-arrow" slot="left"></i>
        <button class="btn" slot="right">发布</button>
      </van-navBar>
    </div>
    <van-field
      class="message"
      v-model="message"
      autosize
      type="textarea"
      placeholder="说点什么...."
    />
    <Uploader class="Uploader" />
  </div>
</template>

<script>
import { NavBar, Field } from 'vant';
import { Uploader } from '@/components';
export default {
  name: 'writeUpdate',
  components: { 'van-navBar': NavBar, 'van-field': Field, Uploader },
  data () {
    return {
      headline: '',
      message: ''
    };
  }
};
</script>

<style lang="less" scoped>
.writeUpdate {
  padding: 0 28px;
  .top-nav-bar {
    flex-shrink: 0;
    width: 100%;
    height: 94px;

    /deep/.van-nav-bar {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 94px;
      margin: auto;
      background-color: #fff;

      &::after {
        border: none;
      }

      .van-nav-bar__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 94px;
        color: #222;
        color: #1a1a1a;
      }

      .van-nav-bar__left {
        left: 0;
      }

      .van-nav-bar__right {
        right: 0;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 94px;
        padding: 0 30px;
      }

      .back-arrow {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/icon_backArrow_01.png");
        background-size: contain;
      }
      .btn {
        width: 96px;
        height: 56px;
        background: linear-gradient(93deg, #2E86FF 0%, #5FA9FF 100%);
        border-radius: 8px;
        font-size: 24px;
        font-weight: 500;
        line-height: 46px;
        color: #fff;
      }
    }
  }
  .message {
    height: 278px;
    margin: 20px auto;
    background: #F9FAFC;
    border-radius: 8px;
  }
  .Uploader {
    margin-top: 40px;
  }
}
</style>